@import "src/style/lib";

.product-list-item {
  position: relative;
  display: flex;
  justify-content: flex-start;
  max-width: calc(100% - 1rem);
  height: fit-content;
  padding: 0.5rem 1rem;
  @media (max-width: 44rem) {
    padding: 0.5rem 0.5rem;
    font-size: 0.9em;
  }
  .accessories-list & {
    padding: 0.5rem 0.5rem;
  }
  border-bottom: 1px solid $bjelin-light-grey;
  background-color: #fff;

  .image-col {
    flex: 0 0 4rem;
    margin-right: 1rem;
    @include media-breakpoint-down("sm") {
      margin-right: 0.5rem;
    }

    .image-container {
      position: relative;
      width: 4rem;
      height: 4rem;
      border-radius: 1rem;
      overflow: hidden;
    }
  }
  .info-col {
    flex: 0 0 calc(100% - 18rem);
    max-width: calc(100% - 18rem);
    margin-right: 1rem;
    padding-top: 0.1rem;
    @include media-breakpoint-between("sm", "lg") {
      flex: 0 0 calc(100% - 17rem);
      max-width: calc(100% - 17rem);
      margin-right: 0.5rem;
    }
    @include media-breakpoint-down("sm") {
      flex: 0 0 calc(100% - 11rem);
      max-width: calc(100% - 11rem);
      margin-right: 0.5rem;
    }

    .accessories-list & {
      flex: 0 0 calc(100% - 17rem);
      max-width: calc(100% - 17rem);
      @include media-breakpoint-between(md, lg) {
        flex: 0 0 calc(100% - 12.5rem);
        max-width: calc(100% - 12.5rem);
      }
      @include media-breakpoint-down("sm") {
        flex: 0 0 calc(100% - 11rem);
        max-width: calc(100% - 11rem);
      }
    }
  }
  .stock-col {
    flex: 0 0 2rem;
    margin-right: 1rem;
    padding-top: 0.8rem;
    @include media-breakpoint-down("md") {
      margin-right: 0;
    }

    @include media-breakpoint-down("sm") {
      position: absolute;
      right: 1rem;
      bottom: 1.2rem;
    }

    .accessories-list & {
      position: static;
      margin-right: 0;
    }

    .stock-status {
      font-size: 0.8rem;
    }
  }
  .cart-col {
    flex: 0 0 15rem;
    @include media-breakpoint-between("sm", "lg") {
      flex: 0 0 10.5rem;
    }
    @include media-breakpoint-down("sm") {
      display: none;
    }

    .accessories-list & {
      flex: 0 0 3rem;
      @include media-breakpoint-between(md, lg) {
        display: none;
      }
    }

    padding-top: 0.3rem;
    display: flex;
    align-items: baseline;
    justify-content: flex-end;

    .amount-cell {
      flex: 0 0 6.5rem;
      margin-right: 1rem;
      @include media-breakpoint-down("sm") {
        flex: 0 0 6rem;
      }
      @include media-breakpoint-down("md") {
        margin-right: 0;
      }

      display: flex;
      align-items: baseline;

      input {
        margin-right: 0.5rem;
      }

      .package-calculator {
        margin-bottom: 0;
      }
    }

    .amount-btn {
      width: 5rem;
      height: 3rem;
      border-radius: 1.5rem;
      white-space: nowrap;
      @include media-breakpoint-down("sm") {
        width: 3rem;
        .btn-label {
          display: none;
        }
      }
    }

    .exists-in-cart {
      font-weight: $headings-font-weight;
      margin-right: 1rem;

      @include media-breakpoint-down("lg") {
        display: none;
      }
    }
  }

  .price-col {
    flex: 0 0 5.5rem;
    align-self: center;
    margin-right: 2rem;
    @include media-breakpoint-between("sm", "lg") {
      margin-right: 1rem;
    }
    @include media-breakpoint-down("sm") {
      margin-right: 0;
      padding-top: 0.1rem;
    }
    font-size: 0.8em;
    text-align: right;
    display: flex;

    .price {
      flex: 0 0 3.5rem;
      display: flex;
      flex-direction: column;
    }

    .stock-cell {
      flex: 0 0 2rem;
      display: flex;
      flex-direction: column;
      padding-top: 0.25rem;
      row-gap: 0.15rem;
    }

    > .price {
      margin-top: 0.2rem;
    }
    > .stock-status {
      margin-top: 0.5rem;
    }

    .accessories-list & {
      margin-right: 1rem;
      @include media-breakpoint-between(md, lg) {
        margin-right: 0;
      }
    }

    .big-price {
      font-size: 1.25em;
      font-weight: $headings-font-weight;
    }

    .previous-unit-price {
      display: inline;
      margin-left: 20px;
      text-decoration: line-through;
    }
  }

  .action-col {
    flex: 0 0 5rem;
    align-self: center;
    padding-top: 0.2rem;
    @include media-breakpoint-down("sm") {
      display: none;
    }
    .info-btn {
      width: 5rem;
      height: 3rem;
      border-radius: 1.5rem;
    }
  }

  .productPreviewImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: $bjelin-light-grey;
    overflow: hidden;
  }

  h4 {
    font-size: 1em;
    margin: 0.2rem 0 0.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tagline {
    font-size: 0.8em;
    line-height: 1.25;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
  }

  .specs {
    font-size: 0.8em;
    line-height: 2em;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
  }

  &.compact {
    .cart-col {
      .exists-in-cart {
        margin-right: 1rem;
        font-size: 1.2em;
      }
    }
  }

  &.no-shop {
    .info-col {
      flex: 0 0 calc(100% - 5rem);
      max-width: calc(100% - 5rem);

      @include media-breakpoint-between("sm", "lg") {
        flex: 0 0 calc(100% - 5rem);
        max-width: calc(100% - 5rem);
      }

      @include media-breakpoint-down("sm") {
        flex: 0 0 calc(100% - 5rem);
        max-width: calc(100% - 5rem);
      }
    }
  }

  &.b2b {
    .info-col {
      flex: 0 0 calc(100% - 30rem);
      max-width: calc(100% - 30rem);

      @include media-breakpoint-between("sm", "lg") {
        flex: 0 0 calc(100% - 24.5rem);
        max-width: calc(100% - 24.5rem);
      }

      @include media-breakpoint-down("sm") {
        flex: 0 0 calc(100% - 11rem);
        max-width: calc(100% - 11rem);
      }
    }

    .price-col {
      flex: 0 0 8rem;
      margin-right: 1rem;

      .price {
        flex: 0 0 4.5rem;
      }

      .stock-cell {
        flex: 0 0 3.5rem;
      }
    }
  }
}
